import React, { Component } from "react";
import { del, get, post, put } from "aws-amplify/api";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Row, Col, Card, InputGroup, Tabs, Tab, Button, Alert, Nav, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "containers/common/Detail.css";
import LeaseReviewList from "containers/property/LeaseReviewList";
import AddressList from "containers/property/AddressList";
import PropertyOwnerList from "containers/property/PropertyOwnerList";
import HeadOfficeModal from "containers/headoffice/HeadOfficeModal";

import AsyncSelect from "react-select/async-creatable";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from "react-select";
import { PacmanLoader } from "react-spinners";
import Moment from "moment";

const API = {
  get: async (apiName, path, options = {}) => {
    const { body } = await get({
      apiName,
      path,
      options: { queryParams: options.queryStringParameters },
    }).response;
    return await body.json();
  },
  post: async (apiName, path, options = {}) => {
    const { body } = await post({
      apiName,
      path,
      options: { body: options.body },
    }).response;
    return await body.json();
  },
  put: async (apiName, path, options = {}) => {
    const { body } = await put({
      apiName,
      path,
      options: { body: options.body },
    }).response;
    return await body.json();
  },
  del: async (apiName, path, options = {}) => {
    const { body } = await del({
      apiName,
      path,
      options: { queryParams: options.queryStringParameters },
    }).response;
    return await body.json();
  },
};

class LeaseDetail extends Component {
  constructor(props) {
    super(props);

    this.handleAddressBuild = this.handleAddressBuild.bind(this);
    this.handleCreateHeadOffice = this.handleCreateHeadOffice.bind(this);
    this.buildAddress = this.buildAddress.bind(this);
    this.toggleHeadOfficeSearchDialog = this.toggleHeadOfficeSearchDialog.bind(this);

    this.updateTableState = this.updateTableState.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    this.refreshDataSet = this.refreshDataSet.bind(this);
    this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
    this.handleAddressClear = this.handleAddressClear.bind(this);
    this.handleDeleteHeadOfficeLink = this.handleDeleteHeadOfficeLink.bind(this);
    this.searchHeadOffices = this.searchHeadOffices.bind(this);
    this.handleAddNew = this.handleAddNew.bind(this);

    this.state = {
      isLoading: null,
      isDeleting: null,
      modified: false,
      lease: null,
      leaseReviewFilter: { leaseid: this.props.match.params.id },
      addressFilter: { propertyid: this.props.match.params.propertyid },
      propertyOwnerFilter: { propertyid: this.props.match.params.propertyid },
      headOfficeFilter: { tenantname: "-1", addressline1: "-1" },
      searchHeadOfficeFlag: false,
      open: true,
      buildingNameFilter: { propertyid: this.props.match.params.propertyid },
      selectedSuburb: null,
      suburbOptions: [],
      suburbFilter: null,
      showAlert: false,
      showWarning: false,
      showHeadOfficeSearchDialog: false,
      warningCounter: 0,
      selectedFronting: null,
      leaseNumberLookup: null,
      clonePropertyKey: null,
      frontingOptions: [],
      frontingFilter: null,
      idList: [],
      propertyidlist: [],
      previousId: null,
      nextId: null,
      currentIdIndex: null,
      currentIdInput: "",

      addresses: [],
      leaseReviews: [],
      propertyOwners: [],
      headOffices: [],
      headOffice: {},
      headOfficeLeases: [],
      headOfficeMatches: [],

      selectedClassification: null,
      classificationOptions: [],
      buildingNameOptions: [],
      selectedBuildingName: null,
      includeLevel: true,

      floorTypeOptions: [
        { value: "Full", label: "Full" },
        { value: "Part", label: "Part" },
      ],
      selectedFloorType: {},
      leaseTermOptions: [
        { value: "Initial", label: "Initial" },
        { value: "Further", label: "Further" },
      ],
      reviewTypeOptions: [],

      searchTypeOptions: [
        { value: "Match", label: "Match" },
        { value: "Contains", label: "Contains" },
        { value: "StartsWith", label: "Starts With" },
      ],

      lessee_trading_orig: null,

      lease_id: null,
      key_part_1: null,
      key_part_2: null,
      property_id: null,
      property_key: this.props.match.params.propertyid,
      property_suburb: null,
      title_details: null,
      registered: null,
      building_name: null,
      lease_number: null,
      old_fmt_lease_number: null,
      original_dealing: null,
      lessee_registered: null,
      acn: null,
      lessee_trading: null,
      suite: null,
      level_desc: null,
      extra_desc: null,
      fronting: null,
      multi_level: null,
      area: null,
      start_date: null,
      expiry_date: null,
      options_text: null,
      options: null,
      sublease: null,
      master_lease_number: null,
      classification_code: null,
      classification: null,
      general_notes: null,
      special_notes: null,
      car_parking: null,
      transferred: null,
      transfer_dealing_number: null,
      still_an_occ: null,
      level_number: null,
      telephone: null,
      floor_type: null,
      old_address_line_1: null,
      old_address_line_2: null,
      address_line_1: null,
      address_line_2: null,
      suburb: null,
      state: null,
      postcode: null,
      fax: null,
      weburl: null,
      email: null,
      include_cs_text: null,
      outs_percent: null,
      outs_per_sqm: null,
      rent_free_period: null,
      base_rent: null,
      base_rent_incl_gst: null,
      number_of_car_parks: null,
      car_parking_rent: null,
      rent_outs_notes: null,
      base_rent_per_sqm: null,
      area_from_lease: null,
      led_head_office_id: null,
      led_head_office_lease_id: null,
      archived: null,
      date_archived: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,
    };
  }

  normalizeSimpleOption = (option, valueKeys = [], labelKeys = []) => {
    if (option == null) {
      return null;
    }

    if (typeof option !== "object") {
      return { value: option, label: option };
    }

    const value = [option.value, ...valueKeys.map((key) => option?.[key])].find((entry) => entry !== undefined && entry !== null && String(entry) !== "");
    const label = [option.label, ...labelKeys.map((key) => option?.[key]), value].find((entry) => entry !== undefined && entry !== null && String(entry) !== "");

    if (value === undefined || value === null || String(value) === "") {
      return null;
    }

    return {
      ...option,
      value,
      label,
    };
  };

  normalizeSuburbOption = (option) => {
    if (!option) {
      return null;
    }

    const normalized = this.normalizeSimpleOption(option, ["suburb", "value"], ["label", "suburb"]);
    if (!normalized) {
      return null;
    }

    const suburbValue = option.suburb ?? normalized.value;
    const stateValue = option.state ?? "";
    const label = option.label ?? `${suburbValue}${stateValue ? ` (${stateValue})` : ""}`;

    return {
      ...normalized,
      suburb: suburbValue,
      state: option.state ?? null,
      postcode: option.postcode ?? null,
      value: label,
      label,
    };
  };

  onUnload(event) {
    // the method that will be used for both add and remove event
    event.returnValue = "Saved";
  }

  componentWillUnmount() {
    this.setState({ lease: [] });
    this.setState({ suburbOptions: [] });
    this.setState({ classificationOptions: [] });
    this.setState({
      isLoading: null,
      isDeleting: null,
      modified: false,
      lease: null,
      clonePropertyKey: null,
      leaseList: [],
      previousId: -1,
      nextId: -1,
      propertyidlist: [],
      leaseReviewFilter: {},
      addressFilter: { propertyid: this.props.match.params.propertyid },
      propertyOwnerFilter: { propertyid: this.props.match.params.propertyid },
      headOfficeFilter: { tenantname: "-1", addressline1: "-1" },
      open: true,
      buildingNameFilter: { propertyid: this.props.match.params.propertyid },
      selectedSuburb: null,
      suburbOptions: [],
      suburbFilter: null,
      showAlert: false,
      showWarning: false,
      showHeadOfficeSearchDialog: false,
      warningCounter: 0,
      selectedFronting: null,
      frontingOptions: [],
      frontingFilter: null,

      addresses: [],
      leaseReviews: [],
      propertyOwners: [],
      headOffices: [],
      headOffice: {},
      headOfficeLeases: [],
      headOfficeMatches: [],

      selectedClassification: null,
      classificationOptions: [],
      buildingNameOptions: [],
      selectedBuildingName: null,
      includeLevel: false,

      floorTypeOptions: [
        { value: "Full", label: "Full" },
        { value: "Part", label: "Part" },
      ],
      selectedFloorType: {},
      leaseTermOptions: [
        { value: "Initial", label: "Initial" },
        { value: "Further", label: "Further" },
      ],
      reviewTypeOptions: [],

      searchTypeOptions: [
        { value: "Match", label: "Match" },
        { value: "Contains", label: "Contains" },
        { value: "StartsWith", label: "Starts With" },
      ],

      lessee_trading_orig: null,

      lease_id: null,
      key_part_1: null,
      key_part_2: null,
      property_id: null,
      property_key: this.props.match.params.propertyid,
      property_suburb: null,
      title_details: null,
      registered: null,
      building_name: null,
      lease_number: null,
      old_fmt_lease_number: null,
      original_dealing: null,
      lessee_registered: null,
      acn: null,
      lessee_trading: null,
      suite: null,
      level_desc: null,
      extra_desc: null,
      fronting: null,
      multi_level: null,
      area: null,
      start_date: null,
      expiry_date: null,
      options_text: null,
      options: null,
      sublease: null,
      master_lease_number: null,
      classification_code: null,
      classification: null,
      general_notes: null,
      special_notes: null,
      car_parking: null,
      transferred: null,
      transfer_dealing_number: null,
      still_an_occ: null,
      level_number: null,
      telephone: null,
      floor_type: null,
      old_address_line_1: null,
      old_address_line_2: null,
      address_line_1: null,
      address_line_2: null,
      suburb: null,
      state: null,
      postcode: null,
      fax: null,
      weburl: null,
      email: null,
      include_cs_text: null,
      outs_percent: null,
      outs_per_sqm: null,
      rent_free_period: null,
      base_rent: null,
      base_rent_incl_gst: null,
      number_of_car_parks: null,
      car_parking_rent: null,
      rent_outs_notes: null,
      base_rent_per_sqm: null,
      area_from_lease: null,
      led_head_office_id: null,
      led_head_office_lease_id: null,
      archived: null,
      date_archived: null,
      created_date: null,
      created_by: null,
      last_edited_date: null,
      last_edited_by: null,
      archived_date: null,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Clean component and reload?
      console.log("Resetting");

      const navigationIds = Array.isArray(this.props.location.state?.data) ? this.props.location.state.data : [];
      const navigationIndex = navigationIds.findIndex((id) => String(id) === String(this.props.match.params.id));

      //  window.location.reload();
      this.setState(
        {
          isLoading: null,
          modified: false,
          isDeleting: null,
          lease: null,
          leaseList: [],
          idList: navigationIndex >= 0 ? navigationIds : [],
          previousId: navigationIndex > 0 ? navigationIds[navigationIndex - 1] : null,
          nextId: navigationIndex >= 0 && navigationIndex + 1 < navigationIds.length ? navigationIds[navigationIndex + 1] : null,
          currentIdIndex: navigationIndex >= 0 ? navigationIndex : null,
          currentIdInput: navigationIndex >= 0 ? String(navigationIndex + 1) : "",
          clonePropertyKey: null,
          leaseReviewFilter: {},
          addressFilter: { propertyid: this.props.match.params.propertyid },
          propertyOwnerFilter: { propertyid: this.props.match.params.propertyid },
          headOfficeFilter: { tenantname: "-1", addressline1: "-1" },
          open: true,
          buildingNameFilter: { propertyid: this.props.match.params.propertyid },
          selectedSuburb: null,
          suburbOptions: [],
          suburbFilter: null,
          showAlert: false,
          showWarning: false,
          showHeadOfficeSearchDialog: false,
          warningCounter: 0,
          selectedFronting: null,
          frontingOptions: [],
          frontingFilter: null,

          addresses: [],
          leaseReviews: [],
          propertyOwners: [],
          headOffices: [],
          headOffice: {},
          headOfficeLeases: [],
          headOfficeMatches: [],

          selectedClassification: null,
          classificationOptions: [],
          buildingNameOptions: [],
          selectedBuildingName: null,
          includeLevel: true,

          floorTypeOptions: [
            { value: "Full", label: "Full" },
            { value: "Part", label: "Part" },
          ],
          selectedFloorType: {},
          leaseTermOptions: [
            { value: "Initial", label: "Initial" },
            { value: "Further", label: "Further" },
          ],
          reviewTypeOptions: [],

          searchTypeOptions: [
            { value: "Match", label: "Match" },
            { value: "Contains", label: "Contains" },
            { value: "StartsWith", label: "Starts With" },
          ],

          lessee_trading_orig: null,

          lease_id: null,
          key_part_1: null,
          key_part_2: null,
          property_id: null,
          property_key: null,
          property_suburb: null,
          title_details: null,
          registered: null,
          building_name: null,
          lease_number: null,
          old_fmt_lease_number: null,
          original_dealing: null,
          lessee_registered: null,
          acn: null,
          lessee_trading: null,
          suite: null,
          level_desc: null,
          extra_desc: null,
          fronting: null,
          multi_level: null,
          area: null,
          start_date: null,
          expiry_date: null,
          options_text: null,
          options: null,
          sublease: null,
          master_lease_number: null,
          classification_code: null,
          classification: null,
          general_notes: null,
          special_notes: null,
          car_parking: null,
          transferred: null,
          transfer_dealing_number: null,
          still_an_occ: null,
          level_number: null,
          telephone: null,
          floor_type: null,
          old_address_line_1: null,
          old_address_line_2: null,
          address_line_1: null,
          address_line_2: null,
          suburb: null,
          state: null,
          postcode: null,
          fax: null,
          weburl: null,
          email: null,
          include_cs_text: null,
          outs_percent: null,
          outs_per_sqm: null,
          rent_free_period: null,
          base_rent: null,
          base_rent_incl_gst: null,
          number_of_car_parks: null,
          car_parking_rent: null,
          rent_outs_notes: null,
          base_rent_per_sqm: null,
          area_from_lease: null,
          led_head_office_id: null,
          led_head_office_lease_id: null,
          archived: null,
          date_archived: null,
          created_date: null,
          created_by: null,
          last_edited_date: null,
          last_edited_by: null,
          archived_date: null,
          previous_number_of_car_parks: null,
        },
        this.componentDidMount
      );
    }
  }

  async newBlankLease() {
    this.setState((state) => ({ property_id: this.props.location.search.replace("?propertyid=", ""), property_key: this.props.match.params.propertyid, created_date: new Date(), last_edited_date: new Date(), created_by: this.props.user, last_edited_by: this.props.user, registered: false, options: false, sublease: false, car_parking: false, still_an_occ: true, include_cs_text: true, base_rent_incl_gst: false, area_from_lease: false, archived: false, transferred: false }), this.synchroniseState);
  }

  async loadTenantNavigation(propertyId) {
    const leaseId = this.props.match.params.id;

    if (!propertyId || leaseId === "new") {
      return;
    }

    const response = await API.get("colin", `/properties/${this.props.match.params.propertyid}/leases`, {
      queryStringParameters: { propertyid: propertyId, archived: "" },
    });
    const records = Array.isArray(response) ? response : response?.data || [];
    const idList = records.map((record) => record.lease_id).filter((id) => id !== null && id !== undefined);
    const currentIdIndex = idList.findIndex((id) => String(id) === String(leaseId));

    if (currentIdIndex >= 0) {
      this.setState({
        idList,
        currentIdIndex,
        currentIdInput: String(currentIdIndex + 1),
        previousId: currentIdIndex > 0 ? idList[currentIdIndex - 1] : null,
        nextId: currentIdIndex + 1 < idList.length ? idList[currentIdIndex + 1] : null,
      });
    }
  }

  // --140660
  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      let leaseRecord = null;
      // await this.getReviewTypes();
      if (this.props.location.state) {
        if (this.props.location.state.data) {
          //If coming from a lease list do some prep work for the previous and next buttons

          const idList = this.props.location.state.data;

          var currentIdIndex = idList.findIndex((id) => String(id) === String(this.props.match.params.id));

          let nextId = null;
          let previousId = null;

          if (currentIdIndex + 1 < idList.length) {
            nextId = idList[currentIdIndex + 1];
          }
          if (currentIdIndex > 0) {
            previousId = idList[currentIdIndex - 1];
          }
          this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex, currentIdInput: String(currentIdIndex + 1) });
        }
        if (this.props.location.state.propertyidlist) {
          this.setState({ propertyidlist: this.props.location.state.propertyidlist });
        }

        if (this.props.location.state.previousId !== undefined && this.props.location.state.previousId !== null) {
          this.setState({ previousId: this.props.location.state.previousId });
        }
      } else {
        this.setState({ nextId: null, previousId: null, currentIdIndex: null, currentIdInput: "" });
      }

      if (this.props.match.params.id === "new") {
        console.log("New lease here");
        //document.getElementById("lease_number").focus();

        if (this.props.location.state) {
          if (this.props.location.state.lease) {
            console.log("Clone lease found");
            let lease = this.props.location.state.lease;
            const created_date = new Date();
            const created_by = this.props.user;
            lease.property_key = this.props.match.params.propertyid;
            lease.property_id = this.props.location.state.propertyid;
            lease.lease_number = null;
            lease.created_date = created_date;
            lease.created_by = created_by;
            lease.last_edited_date = created_date;
            lease.last_edited_by = created_by;

            const { key_part_1, key_part_2, property_suburb, title_details, registered, building_name, old_fmt_lease_number, original_dealing, lessee_registered, acn, lessee_trading, suite, level_desc, extra_desc, fronting, multi_level, area, start_date, expiry_date, options_text, options, sublease, master_lease_number, classification_code, classification, general_notes, special_notes, car_parking, transferred, transfer_dealing_number, still_an_occ, level_number, telephone, floor_type, old_address_line_1, old_address_line_2, address_line_1, address_line_2, suburb, state, postcode, fax, weburl, email, include_cs_text, outs_percent, outs_per_sqm, rent_free_period, base_rent, base_rent_incl_gst, number_of_car_parks, car_parking_rent, rent_outs_notes, base_rent_per_sqm, area_from_lease, archived, led_head_office_id, led_head_office_lease_id, date_archived } = lease;

            this.setState(
              {
                property_id: this.props.location.state.propertyid,
                lease_number: null,
                key_part_1,
                key_part_2,
                property_key: this.props.match.params.propertyid,
                property_suburb,
                title_details,
                registered,
                building_name,
                old_fmt_lease_number,
                original_dealing,
                lessee_registered,
                acn,
                lessee_trading,
                suite,
                level_desc,
                extra_desc,
                fronting,
                multi_level,
                area,
                start_date,
                expiry_date,
                options_text,
                options,
                sublease,
                master_lease_number,
                classification_code,
                classification,
                general_notes,
                special_notes,
                car_parking,
                transferred,
                transfer_dealing_number,
                still_an_occ,
                level_number,
                telephone,
                floor_type,
                old_address_line_1,
                old_address_line_2,
                address_line_1,
                address_line_2,
                suburb,
                state,
                postcode,
                fax,
                weburl,
                email,
                include_cs_text,
                outs_percent,
                outs_per_sqm,
                rent_free_period,
                base_rent,
                base_rent_incl_gst,
                number_of_car_parks,
                car_parking_rent,
                rent_outs_notes,
                base_rent_per_sqm,
                area_from_lease,
                archived,
                led_head_office_id,
                led_head_office_lease_id,
                date_archived,
                created_date: created_date,
                created_by: created_by,
                last_edited_date: created_date,
                last_edited_by: created_by,
                lease,
              },
              async () => {
                //dev
                const result = await this.saveLease(lease);

                if (!result || result.result === false) {
                  alert(result.error_message);
                } else {
                  if (this.props.match.params.id === "new") {
                    this.setState({ lease_id: result.id }, async () => {
                      if (this.state.led_head_office_lease_id) {
                        await this.saveRecord(
                          {
                            led_head_office_id: this.state.led_head_office_id,
                            lease_id: result.id,
                            created_by: this.props.user,
                            last_edited_by: this.props.user,
                            new_record: true,
                          },
                          "headOfficeLeases",
                          "new"
                        );
                      }

                      //Create lease reviews
                      const leaseReviews = await this.createLeaseReviews();
                      if (leaseReviews) {
                        console.log("Finished creating leaseReviews records");
                        let idList = [...this.state.idList];
                        idList.push(this.state.lease_id);

                        alert(`Tenant/Lease record has been cloned to ${this.state.property_key}. Please note: To avoid unwanted duplicates, Lease Number is not populated in the cloned record.`);
                        this.props.history.push(`/properties/${this.state.property_key}/leases/` + this.state.lease_id, { data: idList, propertyidlist: this.state.propertyidlist });
                      }
                    });
                  }
                }
              }
            );
          }
          this.newBlankLease();
        } else {
          this.newBlankLease();
          await this.synchroniseState();
        }
      } else {
        leaseRecord = await this.retrieveLease();
        const incomingIds = this.props.location.state?.data;
        const hasCurrentTenant = Array.isArray(incomingIds) && incomingIds.some((id) => String(id) === String(this.props.match.params.id));
        if (!hasCurrentTenant) {
          await this.loadTenantNavigation(leaseRecord?.property_id);
        }
        const effectivePropertyId = leaseRecord?.property_id || this.state.property_id || this.props.location.search.replace("?propertyid=", "");
        const validation = this.validateRelatedRecord(leaseRecord, "lease");

        if (validation[0] === true && validation[1]) {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showWarning: true });
        }

        if (this.state.lessee_trading) {
          this.setState({ lessee_trading_orig: this.state.lessee_trading });
        }
        this.setState((state) => ({
          frontingFilter: { propertyid: effectivePropertyId },
          addressFilter: { propertyid: effectivePropertyId },
          propertyOwnerFilter: { propertyid: effectivePropertyId },
          buildingNameFilter: { propertyid: effectivePropertyId },
          headOfficeFilter: {
            tenantname: leaseRecord?.lessee_trading,
            addressline1: leaseRecord?.address_line_1,
            addressline2: leaseRecord?.address_line_2,
          },
        }));

        //Get related records
        try {
          this.getStreets({ propertyid: effectivePropertyId });
        } catch {
          alert("Error loading fronting");
        }
        this.getBuildingNamesDropDown({ propertyid: effectivePropertyId });
        try {
          this.getAddresses({ propertyid: effectivePropertyId });
        } catch {
          alert("Error loading building names");
        }

        try {
          this.getPropertyOwners({ propertyid: effectivePropertyId });
        } catch {
          alert("Error loading property owners");
        }
      } //end not new lease

      //If coming from proofing the browse list will be query params not state
      if (this.props.location.search.indexOf("browselist") > 0) {
        const idList = this.props.location.search
          .replace("?browselist=", "")
          .split(",")
          .map((r) => parseInt(r, 10));
        let currentIdIndex = idList.findIndex((id) => String(id) === String(this.props.match.params.id));

        let nextId = null;
        let previousId = null;

        if (currentIdIndex + 1 < idList.length) {
          nextId = idList[currentIdIndex + 1];
        }
        if (currentIdIndex > 0) {
          previousId = idList[currentIdIndex - 1];
        }
        this.setState({ idList: idList, nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex, currentIdInput: String(currentIdIndex + 1) });
      }

      if (this.props.location.state) {
        if (this.props.location.state.searchHeadOfficeFlag) {
          await this.searchHeadOffices();
          this.setState({ searchHeadOfficeFlag: false });
        }
      }

      //Get lookups / initialize selected dropdown values from the fetched lease record.
      const selectedBuildingName = leaseRecord?.building_name
        ? { value: leaseRecord.building_name, label: leaseRecord.building_name }
        : null;
      const selectedClassification = leaseRecord?.classification_code
        ? { value: leaseRecord.classification_code, label: leaseRecord.classification || leaseRecord.classification_code }
        : null;
      const selectedSuburb = leaseRecord?.suburb
        ? {
            value: `${leaseRecord.suburb} (${leaseRecord.state || ""})`,
            label: `${leaseRecord.suburb} (${leaseRecord.state || ""})`,
            suburb: leaseRecord.suburb,
            state: leaseRecord.state,
            postcode: leaseRecord.postcode,
          }
        : null;
      const selectedFronting = leaseRecord?.fronting
        ? { value: leaseRecord.fronting, label: leaseRecord.fronting }
        : null;
      const selectedFloorType = leaseRecord?.floor_type
        ? { value: leaseRecord.floor_type, label: leaseRecord.floor_type }
        : null;

      this.setState({
        selectedBuildingName,
        selectedClassification,
        selectedSuburb,
        selectedFronting,
        selectedFloorType,
      });

      document.title = `${leaseRecord?.property_key || this.state.property_key || ""} ${leaseRecord?.lessee_trading || this.state.lessee_trading || ""}`;

      this.setState({ isLoading: false });
    } catch (e) {
      alert(e);
    }
  }

  async createLeaseReviews() {
    var i;
    let leaseReviews = [...this.props.location.state.leaseReviews];
    for (i = 0; i < leaseReviews.length; i++) {
      leaseReviews[i].lease_id = this.state.lease_id;
      leaseReviews[i].new_record = true;
      const result = await this.saveRecord(leaseReviews[i], "leaseReviews", "lease_review_id");
      if (result.result) {
        leaseReviews[i].lease_review_id = result.id;
        leaseReviews[i].new_record = false;
      } else {
        this.setState({ errorMessage: result.error_message });
        this.setState({ showAlert: true });
      }
    }

    return leaseReviews;
  }
  async synchroniseState() {
console.log("synchroniseState");
    const lease = {
      lease_id: this.state.lease_id,
      key_part_1: this.state.key_part_1,
      key_part_2: this.state.key_part_2,
      property_id: this.state.property_id,
      property_key: this.state.property_key,
      property_suburb: this.state.property_suburb,
      title_details: this.state.title_details,
      registered: this.state.registered,
      building_name: this.state.building_name,
      lease_number: (this.state.lease_number || "").trim(),
      old_fmt_lease_number: this.state.old_fmt_lease_number,
      original_dealing: this.state.original_dealing,
      lessee_registered: this.state.lessee_registered,
      acn: this.state.acn,
      lessee_trading: this.state.lessee_trading,
      suite: this.state.suite,
      level_desc: this.state.level_desc,
      extra_desc: this.state.extra_desc,
      fronting: this.state.fronting,
      multi_level: this.state.multi_level,
      area: this.state.area,
      start_date: this.state.start_date,
      expiry_date: this.state.expiry_date,
      options_text: this.state.options_text,
      options: this.state.options,
      sublease: this.state.sublease,
      master_lease_number: this.state.master_lease_number,
      classification_code: this.state.classification_code,
      classification: this.state.classification,
      general_notes: this.state.general_notes,
      special_notes: this.state.special_notes,
      car_parking: this.state.car_parking,
      transferred: this.state.transferred,
      transfer_dealing_number: this.state.transfer_dealing_number,
      still_an_occ: this.state.still_an_occ,
      level_number: this.state.level_number,
      telephone: this.state.telephone,
      floor_type: this.state.floor_type,
      old_address_line_1: this.state.old_address_line_1,
      old_address_line_2: this.state.old_address_line_2,
      address_line_1: this.state.address_line_1,
      address_line_2: this.state.address_line_2,
      suburb: this.state.suburb,
      state: this.state.state,
      postcode: this.state.postcode,
      fax: this.state.fax,
      weburl: this.state.weburl,
      email: this.state.email,
      include_cs_text: this.state.include_cs_text,
      include_level: this.state.includeLevel,
      outs_percent: this.state.outs_percent,
      outs_per_sqm: this.state.outs_per_sqm,
      rent_free_period: this.state.rent_free_period,
      base_rent: this.state.base_rent,
      base_rent_incl_gst: this.state.base_rent_incl_gst,
      number_of_car_parks: this.state.number_of_car_parks,
      car_parking_rent: this.state.car_parking_rent,
      rent_outs_notes: this.state.rent_outs_notes,
      base_rent_per_sqm: this.state.base_rent_per_sqm,
      area_from_lease: this.state.area_from_lease,
      archived: this.state.archived,
      archived_date: this.state.archived_date,
      led_head_office_id: this.state.led_head_office_id,
      led_head_office_lease_id: this.state.led_head_office_lease_id,
      date_archived: this.state.date_archived,
      created_date: this.state.created_date,
      created_by: this.state.created_by,
      last_edited_date: this.state.last_edited_date,
      last_edited_by: this.state.last_edited_by,
    };

    return new Promise((resolve) => {
      this.setState({ lease }, resolve);
    });
  }

  async retrieveLease() {
    const lease = await this.getLease();

    const { lease_id, key_part_1, key_part_2, property_id, property_key, property_suburb, title_details, registered, building_name, lease_number, old_fmt_lease_number, original_dealing, lessee_registered, acn, lessee_trading, suite, level_desc, extra_desc, fronting, multi_level, area, start_date, expiry_date, options_text, options, sublease, master_lease_number, classification_code, classification, general_notes, special_notes, car_parking, transferred, transfer_dealing_number, still_an_occ, level_number, telephone, floor_type, old_address_line_1, old_address_line_2, address_line_1, address_line_2, suburb, state, postcode, fax, weburl, email, include_cs_text, include_level, outs_percent, outs_per_sqm, rent_free_period, base_rent, base_rent_incl_gst, number_of_car_parks, car_parking_rent, rent_outs_notes, base_rent_per_sqm, area_from_lease, archived, led_head_office_id, led_head_office_lease_id, date_archived, created_date, created_by, last_edited_date, last_edited_by, archived_date, leasereviews } =
      lease;

    this.setState({
      lease,
      lease_id,
      key_part_1,
      key_part_2,
      property_id,
      property_key,
      property_suburb,
      title_details,
      registered,
      building_name,
      lease_number,
      old_fmt_lease_number,
      original_dealing,
      lessee_registered,
      acn,
      lessee_trading,
      suite,
      level_desc,
      extra_desc,
      fronting,
      multi_level,
      area,
      start_date,
      expiry_date,
      options_text,
      options,
      sublease,
      master_lease_number,
      classification_code,
      classification,
      general_notes,
      special_notes,
      car_parking,
      transferred,
      transfer_dealing_number,
      still_an_occ,
      level_number,
      telephone,
      floor_type,
      old_address_line_1,
      old_address_line_2,
      address_line_1,
      address_line_2,
      suburb,
      state,
      postcode,
      fax,
      weburl,
      email,
      include_cs_text,
      includeLevel: typeof include_level === "boolean" ? include_level : true,
      outs_percent,
      outs_per_sqm,
      rent_free_period,
      base_rent,
      base_rent_incl_gst,
      number_of_car_parks,
      car_parking_rent,
      rent_outs_notes,
      base_rent_per_sqm,
      area_from_lease,
      archived,
      led_head_office_id,
      led_head_office_lease_id,
      date_archived,
      created_date,
      created_by,
      last_edited_date,
      last_edited_by,
      archived_date,
      leaseReviews: leasereviews || [],
    });
    this.setState({ previous_number_of_car_parks: number_of_car_parks });
    return lease;
  }

  //Call API
  async getLease() {
    const response = API.get("colin", `/properties/${this.props.match.params.propertyid}/leases/${this.props.match.params.id}`);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getProperty(propertyKey) {
    const response = API.get("colin", `/properties/${propertyKey}`);
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async searchLeaseNumber() {
    const response = API.get("colin", "/leases", { queryStringParameters: { leasenumber: this.state.lease_number, archived: null } });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async saveLease(lease) {
    lease.last_edited_by = this.props.user;

    if (this.props.match.params.id === "new") {
      this.setState((state) => ({ created_by: this.props.user }));
      const response = API.post("colin", `/properties/${this.props.match.params.propertyid}/leases/new`, { body: lease });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    } else {
      const response = API.put("colin", `/properties/` + this.state.property_key + `/leases/${this.props.match.params.id}`, { body: lease });
      try {
        return await response;
      } catch (error) {
        alert(error + ". Please refresh the page (F5) to try again.");
      }
    }
  }

  async saveHeadOffice(headOffice) {
    const response = API.post("colin", `/headoffices/new`, { body: headOffice });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async deleteHeadOfficeLink(headOffice) {
    const response = API.put("colin", `/headoffices/${headOffice.led_head_office_id}/headofficeleases/${headOffice.led_head_office_lease_id}`, { body: headOffice });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getHeadOfficeMatches(filter) {
    const response = API.get("colin", `/headoffices`, { queryStringParameters: filter });
    try {
      return await response;
    } catch (error) {
      alert(error + ". Please refresh the page (F5) to try again.");
    }
  }

  async getAddresses(filter) {
    const pathPropertyId = filter?.propertyid || this.state.property_id || this.props.location.search.replace("?propertyid=", "");
    const normalizedFilter = { ...(filter || {}), propertyid: pathPropertyId };
    try {
      await API.get("colin", "/properties/" + pathPropertyId + "/addresses", { queryStringParameters: normalizedFilter }).then((addresses) => {
        if (addresses) {
          this.setState((state) => ({ addresses }));
        }
      });
    } catch {
      alert("Error getting addresses. Please refresh the page (F5) to try again");
    }
  }

  async getBuildingNamesDropDown(filter) {
    const queryPropertyId = String(filter?.propertyid || this.state.property_id || this.props.location.search.replace("?propertyid=", "") || this.props.match.params.propertyid || "").trim();
    const normalizedFilter = {
      ...(filter || {}),
      propertyid: queryPropertyId,
    };
    try {
      await API.get("colin", `/buildingnames/dropdown`, { queryStringParameters: normalizedFilter }).then((buildingNameOptions) => {
        if (buildingNameOptions) {
          const normalizedBuildingNameOptions = (buildingNameOptions || [])
            .map((option) => this.normalizeSimpleOption(option, ["building_name"], ["building_name"]))
            .filter(Boolean);

          this.setState((state) => ({ buildingNameOptions: normalizedBuildingNameOptions }));
        }
      });
    } catch {
      alert("Error getting building names. Please refresh the page (F5) to try again");
    }
  }

  async getPropertyOwners(filter) {
    const queryPropertyId = filter?.propertyid || this.state.property_id || this.props.location.search.replace("?propertyid=", "");
    const normalizedFilter = { ...(filter || {}), propertyid: queryPropertyId };
    try {
      API.get("colin", "/propertyowners", { queryStringParameters: normalizedFilter }).then((propertyOwners) => {
        if (propertyOwners) {
          this.setState((state) => ({ propertyOwners }));
        }
      });
    } catch {
      alert("Error getting property owners. Please refresh the page (F5) to try again");
    }
  }

async getStreets(filter) {
    const queryPropertyId = filter?.propertyid || this.state.property_id || this.props.location.search.replace("?propertyid=", "");
    const normalizedFilter = { ...(filter || {}), propertyid: queryPropertyId };
    try {
      await API.get("colin", `/streets`, { queryStringParameters: normalizedFilter }).then((frontingOptions) => {
        if (frontingOptions) {
          const normalizedFrontingOptions = (frontingOptions || [])
            .map((option) => this.normalizeSimpleOption(option, ["street_name", "fronting", "name"], ["street_name", "fronting", "name"]))
            .filter(Boolean);

          this.setState((state) => ({ frontingOptions: normalizedFrontingOptions }));
        }
      });
    } catch {
      alert("Error getting streets. Please refresh the page (F5) to try again");
    }
  }

  handleEnterCurrentIdIndex = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleGoToRecord();
    }
  };

  handleGoToRecord = () => {
    const isWholePage = /^\d+$/.test(this.state.currentIdInput);
    const pageNumber = isWholePage ? Number.parseInt(this.state.currentIdInput, 10) : Number.NaN;
    const nextIndex = pageNumber - 1;

    if (nextIndex >= 0 && nextIndex < this.state.idList.length) {
      this.props.history.push({ pathname: `/properties/${this.state.property_key}/leases/${this.state.idList[nextIndex]}`, state: { data: this.state.idList, propertyidlist: this.state.propertyidlist } });
    } else {
      this.setState({ currentIdInput: String(this.state.currentIdIndex + 1) });
      alert("Page no not in range.");
    }
  };

  handleCurrentIdIndexChange = (event) => {
    this.setState({ currentIdInput: event.target.value });
  };

  loadOptions = async (inputValue) => {
    if (inputValue.length >= 3) {
      //We hacked this to use the cityscope as the suburb param to avoid an RFC
      const suburbs = await API.get("colin", `/suburbs`, { queryStringParameters: { cityscope: inputValue } });
      return (suburbs || []).map(this.normalizeSuburbOption).filter(Boolean);
    } else {
      return [];
    }
  };

  handleSuburbChange = (selectedSuburb) => {
    this.setState({ selectedSuburb, suburb: selectedSuburb.suburb, state: selectedSuburb.state, postcode: selectedSuburb.postcode, modified: true }, this.handleBlur);
  };
  handleCreateSuburb = (suburb) => {
    this.setState({ suburb: suburb, selectedSuburb: { label: suburb, value: suburb }, state: "", postcode: "", modified: true }, this.handleBlur);
  };

  handleClassificationChange = (selectedClassification) => {
    this.setState({ selectedClassification, classification_code: selectedClassification.value, modified: true }, this.handleBlur);
  };

  handleFrontingChange = (selectedFronting) => {
    if (selectedFronting) {
      this.setState({ selectedFronting, fronting: selectedFronting.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedFronting: { value: null, label: null }, fronting: null, modified: true }, this.handleBlur);
    }
  };

  handleFloorTypeChange = (selectedFloorType) => {
    this.setState({ selectedFloorType, floor_type: selectedFloorType.value, modified: true }, this.handleBlur);
  };

  handleBuildingNameChange = (selectedBuildingName) => {
    if (selectedBuildingName) {
      this.setState({ selectedBuildingName, building_name: selectedBuildingName.value, modified: true }, this.handleBlur);
    } else {
      this.setState({ selectedBuildingName: { value: null, label: null }, building_name: "", modified: true }, this.handleBlur);
    }
  };

  handleAddressBuild() {
    if (this.state.address_line_1 || this.state.suburb) {
      const confirmed = window.confirm("Are you sure you want to overwrite existing address?");

      if (!confirmed) {
        return;
      }
    }

    var mainAddress;
    if (this.state.addresses) {
      for (var i = 0; i < this.state.addresses.length; i++) {
        if (this.state.addresses[i].main_address === true) {
          mainAddress = this.state.addresses[i];

          break;
        }
      }
      this.buildAddress(mainAddress);
    }
  }

  handleAddressClear() {
    console.log("handle clear address");
    const confirmed = window.confirm("Are you sure you want to clear this address");

    if (!confirmed) {
      return;
    } else {
      this.setState({ address_line_1: "", address_line_2: "", suburb: "", state: "", postcode: "", selectedSuburb: { value: "", label: "" }, modified: true }, this.handleBlur);
    }
  }

  async handleCreateHeadOffice() {
    console.log("in handle create head office");
    if (this.state.lessee_trading !== null) {
      console.log("proceeding");
      const confirmed = window.confirm("This function creates a Head Office record based on the details entered for this lease (address, telephone, fax, internet and email). Proceed?");

      if (!confirmed) {
        return;
      }
      let headOffice = {};

      headOffice.tenant_name = this.state.lessee_trading;
      headOffice.address_line_1 = this.state.address_line_1;
      headOffice.address_line_2 = this.state.address_line_2;
      headOffice.suburb = this.state.suburb;
      headOffice.state = this.state.state;
      headOffice.postcode = this.state.postcode;
      headOffice.telephone = this.state.telephone;
      headOffice.fax = this.state.fax;
      headOffice.weburl = this.state.weburl;
      headOffice.email = this.state.email;
      //            headOffice.notes = this.state.notes;
      headOffice.created_by = this.props.user;
      headOffice.last_edited_by = this.props.user;
      headOffice.lease_id = this.state.lease_id;

      const validation = this.validateRelatedRecord(this.state.headOffice, "headOffice");

      if (validation[0] === true) {
        const result = await this.saveHeadOffice(headOffice);
        if (result.result === false) {
          alert(result.error_message);
        } else {
          const led_head_office_id = result.id;
          const led_head_office_lease_id = result.led_head_office_lease_id ?? result.head_office_lease_id ?? null;
          await new Promise((resolve) =>
            this.setState(
              {
                led_head_office_id,
                led_head_office_lease_id,
              },
              resolve
            )
          );

          // Some API responses do not include the link id immediately.
          // Refresh lease so break-link can use the correct led_head_office_lease_id without a page reload.
          if (!led_head_office_lease_id) {
            await this.retrieveLease();
          }

          //this.props.history.push(`../../../../headoffices/${led_head_office_id}`)
        }
      }
    } else {
      console.log("No lessee trading");
      alert("No lessee trading entered so cannot create a head office.");
    }
  }

  async handleDeleteHeadOfficeLink() {
    var r = window.confirm("Are you sure you want to break the link to the head office?");
    if (r === true) {
      const ledHeadOfficeId = this.state.led_head_office_id;
      const ledHeadOfficeLeaseId = this.state.led_head_office_lease_id;

      if (!ledHeadOfficeId || ledHeadOfficeId === "null" || !ledHeadOfficeLeaseId || ledHeadOfficeLeaseId === "null") {
        alert("Cannot break Head Office link because the link identifier is missing. Please refresh and try again.");
        return;
      }

      let headOffice = {};

      headOffice.led_head_office_id = ledHeadOfficeId;
      headOffice.led_head_office_lease_id = ledHeadOfficeLeaseId;
      headOffice.archived_date = new Date();
      headOffice.last_edited_by = this.props.user;

      const result = await this.deleteHeadOfficeLink(headOffice);
      if (result.result === false) {
        alert(result.error_message);
      } else {
        this.setState({ led_head_office_id: null, led_head_office_lease_id: null });
      }
    }
  }
  async buildAddress(address) {
    if (this.state.includeLevel === true) {
      var level = "";
      if (this.state.level_desc !== null && this.state.level_desc !== "") {
        level = this.state.level_desc;
      }
      if (this.state.suite !== null && this.state.suite !== "") {
        level = this.state.suite + ", " + level;
      }

      if ((this.state.suite === null || this.state.suite.length === 0) && (this.state.level_desc === null || this.state.level_desc.length === 0)) {
        this.setState({ address_line_1: address.street_address, address_line_2: "" });
      } else {
        this.setState({ address_line_1: level, address_line_2: address.street_address });
      }
    } else {
      this.setState({ address_line_1: address.street_address, address_line_2: "" });
    }

    this.setState({ suburb: address.suburb, state: address.state, postcode: address.postcode, selectedSuburb: { value: address.suburb + " (" + address.state + ")", label: address.suburb + " (" + address.state + ")" }, modified: true }, this.handleBlur);
  }

  refreshDataSet = async (dataset) => {
    //Get nabers records

    switch (dataset) {
      case "addresses":
        try {
          await this.getAddresses(this.state.addressFilter);
        } catch {
          alert("Error loading addresses");
        }
        break;
      case "propertyOwners":
        try {
          await this.getPropertyOwners(this.state.propertyOwnerFilter);
        } catch {
          alert("Error loading property owners");
        }
        break;
      default:
        console.log("Nothing to do");
        break;
    }
  };

  validateRelatedRecord(record, set) {
    //property
    if (set === "lease") {
      if (!this.state.property_key) {
        return [false, "ALERT!: Enter a Cityscope reference. Changes to this record WILL NOT BE SAVED until fixed."];
      }

      if (this.state.registered) {
        if (!this.state.lease_number) {
          return [false, "ALERT!: Enter a lease number. Changes to this record WILL NOT BE SAVED until fixed."];
        }
      }

      if (this.state.include_cs_text && !this.state.lessee_trading) {
        return [true, "ALERT!: You have selected to include in Cityscope text but not entered a lessee trading."];
      }
      if (!this.state.lessee_trading && !this.state.lessee_registered && this.state.still_an_occ) {
        return [true, "You have indicated the occupant is still there but have not provided lessee trading or registered. Enter a lessee OR remove Include in Text AND Still Here. The record HAS still been SAVED."];
      }
    }

    //lease review Validation
    if (set === "leaseReviews") {
      var regex = /[a-zA-Z]/;

      //Check street name not blank
      if (record.percentage) {
        if (regex.test(record.percentage)) {
          return [false, "Percentage must be numeric"];
        }

        if (record.percentage < 0 || record.percentage > 100) {
          return [false, "Percentage must be between 0 and 100"];
        }
      }

      if (!record.lease_term) {
        return [false, "ALERT!: Lease Term cannot be blank. Changes to this record WILL NOT BE SAVED until fixed."];
      }

      if (!record.review_type_code) {
        return [false, "ALERT!: Review Type cannot be blank. Changes to this record WILL NOT BE SAVED until fixed."];
      }

      if (record.revised_price_per_sqm) {
        if (regex.test(record.revised_price_per_sqm)) {
          return [false, "Rental price per sqm must be numeric"];
        }
      }
      if (record.revised_price_per_annum) {
        if (regex.test(record.revised_price_per_annum)) {
          return [false, "Rental price per annum must be numeric"];
        }
      }
    }

    return [true];
  }

  async updateTableState(data, set) {
    this.setState({
      [set]: data,
    });
  }

  async saveRecord(record, endpoint, id) {
    record.last_edited_by = this.props.user;
    const effectivePropertyId = this.state.property_id || this.props.location.search.replace("?propertyid=", "") || this.state.property_key || this.props.match.params.propertyid;
    //If the record is a new record perform a post
    if (record.hasOwnProperty("new_record")) {
      if (record.new_record === true) {
        record.last_edited_by = this.props.user;
        if (endpoint === "headOfficeLeases") {
          return API.post("colin", `/headoffices/${record.led_head_office_id}/headofficeleases/new`, {
            body: record,
          });
        } else {
          return API.post("colin", `/properties/${effectivePropertyId}/${endpoint.toLowerCase()}/new`, {
            body: record,
          });
        }
      }
    }
    //If not a new record and updating an existing, perform a put
    if (endpoint === "headOfficeLeases") {
      return API.put("colin", `/headoffices/${record.led_head_office_id}/headofficeleases/${record[id]}`, {
        body: record,
      });
    } else {
      return API.put("colin", `/properties/${effectivePropertyId}/${endpoint.toLowerCase()}/${record[id]}`, {
        body: record,
      });
    }
  }

  deleteRecord(endpoint, params) {
    return API.del("colin", `/${endpoint}`, { queryStringParameters: params });
  }

  handleMoneyChange = (event) => {
    const fieldName = event.target.id || event.target.name;
    if (!fieldName) {
      return;
    }
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      currencyDisplay: "symbol",
    });
    if (event.target.value !== "") {
      let val = currencyFormatter.format(event.target.value.replace(/[^0-9.]/g, ""));
      this.setState({ [fieldName]: val, modified: true });
    } else {
      this.setState({ [fieldName]: null, modified: true });
    }
  };

  handleNumberChange = (event) => {
    const fieldName = event.target.id || event.target.name;
    if (!fieldName) {
      return;
    }
    let val = "";
    if (event.target.value) {
      val = event.target.value.replace(/[^0-9.]/g, "");
    } else {
      val = null;
    }
    // secondly check that UnitSort has been specified if required

    this.setState({
      [fieldName]: val,
    });
    this.setState({ modified: true });
  };
  handlePercentChange = (event) => {
    const fieldName = event.target.id || event.target.name;
    if (!fieldName) {
      return;
    }
    let val = event.target.value.replace(/[^0-9.]/g, "").replace(/(?<=[.][0-9]{6})[0-9]*/g, "");
    if (val > 100) {
      val = 100;
    }

    this.setState({ [fieldName]: val, modified: true });
  };
  handleChange = (event) => {
    const fieldName = event.target.id || event.target.name;
    if (!fieldName) {
      return;
    }
    this.setState({
      [fieldName]: event.target.value,
    });
    this.setState({ modified: true });
  };

  handleLeaseNumberLookup = (event) => {
    if (this.state.leaseNumberLookup === null || this.state.leaseNumberLookup.length === 0) {
      return;
    }

    const doesNotExistText = `Lease Number ${this.state.leaseNumberLookup} does not exist.`;

    API.get("colin", `/leases/exists_by_number/${this.state.leaseNumberLookup}`)
      .then(async (response) => {
        if (!response.hasOwnProperty("lease_id") || !response.hasOwnProperty("property_key")) {
          alert(doesNotExistText);
          return;
        }

        const propertyKey = response.property_key;
        const leaseId = response.lease_id;
        let confirmationMessage = "Lease number exists, do you want to be redirected there now?";
        let navData = { data: this.state.idList, propertyidlist: this.state.propertyidlist };

        if (!this.state.idList.includes(leaseId)) {
          confirmationMessage = "The Lease number exists, BUT on a different property. Do you want to be redirected there now?";
          navData = null;
        }

        const redirect = window.confirm(confirmationMessage);

        if (!redirect) {
          return;
        }

        this.props.history.push(`/properties/${propertyKey}/leases/${leaseId}`, navData);
      })
      .catch((error) => {
        console.error(`/leases/exists_by_number/${this.state.leaseNumberLookup}:`, error);
        alert(doesNotExistText);
      });
  };

  handleDateChange(date, name) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    var dt = new Date(date);

    if (date) {
      this.setState({
        [name]: dt.toLocaleDateString("en-AU", options),
        modified: true,
      });
    } else {
      this.setState({
        [name]: null,
        modified: true,
      });
    }
  }

  handleCheckBoxChange = (event) => {
    let name = event.target.name;
        if (name === "archived") {
      let date_archived = this.state.date_archived;
      if (!event.target.checked) {
        date_archived = null;
      }
      this.setState(
        {
          [name]: event.target.checked,
          modified: true,
          date_archived: date_archived,
        },
        this.handleBlur
      );
    } else {
      this.setState(
        {
          [name]: event.target.checked,
          modified: true,
        },
        this.handleBlur
      );
    }
  };

  handleMasterLeaseChange = (event) => {
    this.handleChange(event);
    this.setState({ sublease: !!event.target.value });
  };

  handleSubleaseChange = (event) => {
    this.handleCheckBoxChange(event);
    this.synchroniseState().then(() => {
      if (!this.state.sublease) {
        this.setState({ master_lease_number: "" });
      }
    });
  };

  async searchHeadOffices() {
    const lesseeTrading = (this.state.lessee_trading || "").trim();

    if (!lesseeTrading) {
      alert("Please enter Lessee Trading before searching for a Head Office link.");
      return;
    }

    const headOfficeMatches = await this.getHeadOfficeMatches({
      name: lesseeTrading,
      tenantname: lesseeTrading,
      state: this.state.state,
      addressline1: this.state.address_line_1,
      addressline2: this.state.address_line_2,
    });

    if (headOfficeMatches && headOfficeMatches.length > 0) {
      this.setState({ headOfficeMatches });
      this.setState({ showHeadOfficeSearchDialog: true });
      return;
    }
  }

  handleLeaseBlur = async (event) => {
    if (this.state.lease_number) {
      if (this.state.lease_number !== this.state.lease.lease_number) {
        const existingLeases = await this.searchLeaseNumber();

        if (existingLeases.length > 0) {
          if (existingLeases[0].lease_id !== this.state.lease_id) {
            //there should only be one match result
            const confirmed = window.confirm(existingLeases[0].archived ? "The Lease number you have entered exists, but the record has been archived. Do you want to retrieve the archived record?" : "Lease number exists, do you want to be redirected there now?");

            if (confirmed) {
              if (existingLeases[0].property_key === this.state.property_key) {
                this.props.history.push("/properties/" + existingLeases[0].property_key + "/leases/" + existingLeases[0].lease_id, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
                return;
              } else {
                this.props.history.push("/properties/" + existingLeases[0].property_key + "/leases/" + existingLeases[0].lease_id, { data: [] });
                return;
              }
            } else {
              this.setState({ lease_number: "" });
            }
          }
        } else {
          this.handleBlur();
        }
      }
    }
  };
  handleBlur = async (event) => {
    const currencyFormatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    });
    if (event && this.state.modified) {
      if (event.target) {
        const targetField = event.target.id || event.target.name;
        if (targetField && event.target.type !== "checkbox" && this.state[targetField] !== event.target.value) {
          await new Promise((resolve) => this.setState({ [targetField]: event.target.value }, resolve));
        }

        if (["base_rent", "base_rent_per_sqm", "car_parking_rent", "outs_per_sqm"].indexOf(event.target.id) >= 0) {
          if (event.target.id === "base_rent_per_sqm" && this.state.base_rent !== "" && this.state.base_rent !== null) {
            const result = window.confirm("You cannot have base rent per annum and per sqm. Do you want to proceed with per sqm and the per annum value will be removed?");
            if (result) {
              this.setState({ base_rent: "" });
            } else {
              this.setState({ [event.target.id]: "" });
              return;
            }
          }
          if (event.target.id === "base_rent" && this.state.base_rent_per_sqm !== "" && this.state.base_rent_per_sqm !== null) {
            const result = window.confirm("You cannot have base rent per annum and per sqm. Do you want to proceed with per annum and the per sqm value will be removed?");
            if (result) {
              this.setState({ base_rent_per_sqm: "" });
            } else {
              this.setState({ [event.target.id]: "" });
              return;
            }
          }
          if (this.state[event.target.id]) {
            this.setState({ [event.target.id]: currencyFormatter.format(this.state[event.target.id].replace(/[^0-9.]/g, "")) });
          }
        }

        if (event.target.id === "number_of_car_parks" && event.target.value > 254) {
          alert("No. Car Parks may not exceed 254.");
          const prevValue = this.state.previous_number_of_car_parks > 254 ? 254 : this.state.previous_number_of_car_parks;
          await this.setState({ number_of_car_parks: prevValue === null ? "" : prevValue });
          return;
        }
        if (event.target.id === "number_of_car_parks" && event.target.value < 0) {
          alert("No. Car Parks may not be a negative number.");
          const prevValue = this.state.previous_number_of_car_parks < 0 ? 0 : this.state.previous_number_of_car_parks;
          await this.setState({ number_of_car_parks: prevValue === null ? "" : prevValue });
          return;
        }
      }
    }

    if (this.state.modified === true) {
      console.log(this.state);

      //check if lease number already exists

      //check if the lessee trading has been changed, if it has, check if a head office record exists
      if (this.state.lessee_trading_orig !== this.state.lessee_trading && this.state.lessee_trading && !this.state.led_head_office_id && this.props.match.params.id.indexOf("new") === -1) {
        if (this.props.match.params.id === "new") {
          await this.searchHeadOffices();
          this.setState({ lessee_trading_orig: this.state.lessee_trading });
          return;
        } else {
          await this.searchHeadOffices();
          this.setState({ lessee_trading_orig: this.state.lessee_trading });
        }
      }

      let registered = this.state.lease_number == null || this.state.lease_number === "" ? false : true;
      let include = this.state.still_an_occ ? this.state.include_cs_text : false;

      this.setState({ showAlert: false, showWarning: false, last_edited_by: this.props.user, registered: registered, include_cs_text: include }, this.synchroniseState);
      await this.synchroniseState();

      const validation = this.validateRelatedRecord(this.state.lease, "lease");
      console.log(validation);
      if (validation[0] === true) {
        if (validation[1]) {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showWarning: true });
        }
        try {
          this.setState((state) => ({ modified: false }));
          if (this.props.match.params.id === "new") {
            this.setState({ isLoading: true });
          }
          const result = await this.saveLease(this.state.lease);
          this.setState({ isLoading: false });
          this.setState({ previous_number_of_car_parks: this.state.number_of_car_parks });
          if (result.result === false) {
            if (result.error_message === "Lease number already exists") {
              const confirmed = window.confirm("Lease number exists, do you want to be redirected there now?");
              if (confirmed) {
                this.props.history.push("/properties/" + this.state.property_key + "/leases/" + result.id);
              } else {
                this.setState({ lease_number: "" });
              }
            } else {
              alert(result.error_message);
            }
          } else {
            console.log(result);
            if (this.props.match.params.id === "new") {
              this.setState((state) => ({ lease_id: result.id }));

              if (this.state.currentIdIndex !== null) {
                let idList = this.state.idList;
                idList.push(result.id);
                this.setState({ idList });
              }
              this.props.history.push("/properties/" + this.state.property_key + "/leases/" + result.id, { data: this.state.idList, propertyidlist: this.state.propertyidlist, searchHeadOfficeFlag: this.state.lessee_trading ? true : false });
            }
          }
        } catch (e) {
          alert(e);
        }
      } else {
        if (validation[1].indexOf(" WILL NOT BE SAVED" > 0)) {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showAlert: true });
        } else {
          this.setState({ errorMessage: validation[1] });
          this.setState({ showAlert: true });
        }
      }
    } else {
      if (this.props.match.params.id === "new" && this.state.warningCounter === 0) {
        // const confirmed = window.confirm(
        //     "Is the new record a registered lease? If so, you need to enter a lease number to make sure it doesn't already exist? Click CANCEL to create a tenancy record."
        // );
        // if(!confirmed){
        this.setState({ warningCounter: this.state.warningCounter + 1, lessee_trading: "", lessee_trading_orig: "", modified: true }, this.handleBlur);
        // }
        // else{
        //     this.setState({warningCounter: this.state.warningCounter+1});
        // }
      }
    }
  };

  async createNewLease() {
    console.log("createNewLease");
    const confirmed2 = window.confirm("Would you like to create a new lease record with this tenancy information preserved?");

    if (!confirmed2) {
      return null;
    } else {
      let newLease = {
        property_id: this.state.property_id,
        created_date: new Date(),
        last_edited_date: new Date(),
        created_by: this.props.user,
        last_edited_by: this.props.user,
        registered: false,
        property_key: this.state.property_key,
        building_name: this.state.building_name,
        suite: this.state.suite,
        level: this.state.level,
        level_desc: this.state.level_desc,
        extra_desc: this.state.extra_desc,
        fronting: this.state.fronting,
        multi_level: this.state.multi_level,
        level_number: this.state.level_number,
        floor_type: this.state.floor_type,
        area: this.state.area,
        general_notes: this.state.general_notes,
        transferred: this.state.transferred,
        area_from_lease: this.state.area_from_lease,
        options: false,
        sublease: this.state.sublease,
        car_parking: this.state.car_parking,
        still_an_occ: this.state.still_an_occ,
        include_cs_text: this.state.include_cs_text,
        include_level: this.state.includeLevel,
        base_rent_incl_gst: this.state.base_rent_incl_gst,

        archived: false,
        lessee_registered: null,
        acn: null,
        lessee_trading: null,
        classification_code: null,
        telephone: null,
        fax: null,
        weburl: null,
        email: null,
        address_line_1: null,
        address_line_2: null,
        suburb: null,
        state: null,
        postcode: null,
        new_record: true,
      };

      const confirmed3 = window.confirm("Same tenant? Press cancel to not copy the tenant.");

      if (confirmed3) {
        newLease.lessee_registered = this.state.lessee_registered;
        newLease.acn = this.state.acn;
        newLease.lessee_trading = this.state.lessee_trading;
        newLease.classification_code = this.state.classification_code;
        newLease.telephone = this.state.telephone;
        newLease.fax = this.state.fax;
        newLease.weburl = this.state.weburl;
        newLease.email = this.state.email;
        newLease.address_line_1 = this.state.address_line_1;
        newLease.address_line_2 = this.state.address_line_2;
        newLease.suburb = this.state.suburb;
        newLease.state = this.state.state;
        newLease.postcode = this.state.postcode;
        console.log(newLease);
      } else {
        newLease.lessee_registered = null;
        newLease.acn = null;
        newLease.lessee_trading = null;
        newLease.classification_code = null;
        newLease.telephone = null;
        newLease.fax = null;
        newLease.weburl = null;
        newLease.email = null;
        newLease.address_line_1 = null;
        newLease.address_line_2 = null;
        newLease.suburb = null;
        newLease.state = null;
        newLease.postcode = null;
      }

      const result = await this.saveRecord(newLease, "leases", "new");
      console.log(result);
      if (result.result) {
        console.log("Got result - " + result.result);
        if (confirmed3) {
          if (this.state.led_head_office_lease_id) {
            await this.saveRecord(
              {
                led_head_office_id: this.state.led_head_office_id,
                lease_id: result.id,
                created_by: this.props.user,
                last_edited_by: this.props.user,
                new_record: true,
              },
              "headOfficeLeases",
              "new"
            );
          }
        }
        return result.id;
      } else {
        this.setState({ errorMessage: result.error_message });
        this.setState({ showAlert: true });
      }
    }
  }

  handleArchive = async (event) => {
    event.preventDefault();
    console.log("handleArchive");

    const confirmed = window.confirm("Are you sure you want to archive this lease?");

    if (!confirmed) {
      return;
    } else {
      if (this.state.currentIdIndex !== null) {
        let idList = this.state.idList;
        idList.splice(this.state.currentIdIndex, 1);
        this.setState({ idList });
      }
      console.log("We need to create a new lease");
      const newLeaseId = await this.createNewLease();
      console.log(newLeaseId);
      this.setState({ archived: true, include_cs_text: false, still_an_occ: false }, () =>
        this.setState({ date_archived: new Date() }, () =>
          this.synchroniseState().then(async () => {
            const result = await this.saveLease(this.state.lease);
            if (result.result === false) {
              alert(result.error_message);
            } else {
              if (newLeaseId) {
                let idList = this.state.idList;
                idList.splice(this.state.currentIdIndex, 0, newLeaseId);
                console.log("Add id " + newLeaseId + " to idList");
                this.setState({ idList });
                this.props.history.push(`/properties/${this.state.property_key}/leases/${newLeaseId}`, { data: idList, propertyidlist: this.state.propertyidlist });
              } else {
                if (this.state.nextId) {
                  this.props.history.push(`/properties/${this.state.property_key}/leases/${this.state.nextId}`, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
                } else if (this.state.previousId) {
                  this.props.history.push(`/properties/${this.state.property_key}/leases/${this.state.previousId}`, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
                } else {
                  this.props.history.push(`/properties/${this.state.property_key}`, { data: this.state.propertyidlist });
                }
              }
            }
          })
        )
      );
    }
  };

  handleDelete = async (event) => {
    event.preventDefault();
    console.log("handleDelete");
    if (!this.state.registered && !this.state.lease_number && this.state.leaseReviews.length === 0) {
      const confirmed = window.confirm("Are you sure you want to delete this lease?");

      if (!confirmed) {
        return;
      } else {
        if (this.state.currentIdIndex !== null) {
          let idList = this.state.idList;
          idList.splice(this.state.currentIdIndex, 1);
          this.setState({ idList });
        }
        this.createNewLease().then((newLeaseId) => {
          console.log("New lease call back " + newLeaseId);
          this.setState({ include_cs_text: false, still_an_occ: false, lessee_trading: null, lessee_registered: null, acn: null, registered: false, car_parking: null, classification_code: null, telephone: null, fax: null, weburl: null, email: null, address_line_1: null, address_line_2: null, suburb: null, state: null, postcode: null, lease_number: null, sublease: false, master_lease_number: null, old_fmt_lease_number: null, original_dealing: null, transferred: false, transfer_dealing_number: null, start_date: null, expiry_date: null, options_text: null, options: false, special_notes: null, archived_date: new Date() }, () =>
            this.synchroniseState().then(async () => {
            const result = await this.saveLease(this.state.lease);
            if (result.result === false) {
              alert(result.error_message);
            } else {
              if (newLeaseId) {
                let idList = this.state.idList;
                idList.splice(this.state.currentIdIndex, 0, newLeaseId);

                this.setState({ idList });
                this.props.history.push(`/properties/${this.state.property_key}/leases/${newLeaseId}`, { data: idList, propertyidlist: this.state.propertyidlist });
              } else {
                if (this.state.nextId) {
                  this.props.history.push(`/properties/${this.state.property_key}/leases/${this.state.nextId}`, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
                } else if (this.state.previousId) {
                  this.props.history.push(`/properties/${this.state.property_key}/leases/${this.state.previousId}`, { data: this.state.idList, propertyidlist: this.state.propertyidlist });
                } else {
                  this.props.history.push(`/properties/${this.state.property_key}`, { data: this.state.propertyidlist });
                }
              }
            }
          })
          );
        });
      }
    } else {
      window.alert("This record contains lease details and should be archived.");
    }
  };

  async toggleHeadOfficeSearchDialog() {
    this.setState({
      showHeadOfficeSearchDialog: !this.state.showHeadOfficeSearchDialog,
    });
    await this.retrieveLease();
  }

  handleClone = async (event) => {
    event.preventDefault();
    const property = await this.getProperty(this.state.clonePropertyKey || this.state.property_key);
    const property_id = await property.property_id;
    if (property_id) {
      const confirmed = window.confirm(`Are you sure you want to create a copy of this Tenant/Lease record attached to ${this.state.clonePropertyKey || this.state.property_key}?`);
      if (!confirmed) {
        return;
      }
    } else {
      alert("The Cityscope Reference you have entered does not exist. Please check and try again.");
      this.setState({ clonePropertyKey: "" });

      return;
    }

    if ((this.state.clonePropertyKey || this.state.property_key) !== this.state.property_key) {
      console.log("Loading with no id list");
      this.props.history.push(`/properties/${this.state.clonePropertyKey || this.state.property_key}/leases/new`, { propertyid: property_id, leaseReviews: this.state.leaseReviews, lease: this.state.lease });
    } else {
      this.props.history.push(`/properties/${this.state.clonePropertyKey || this.state.property_key}/leases/new`, { propertyid: property_id, leaseReviews: this.state.leaseReviews, lease: this.state.lease, data: this.state.idList, propertyidlist: this.state.propertyidlist });
    }
  };

  handleAddNew = () => {
    this.props.history.push(`/properties/${this.state.property_key}/leases/new?propertyid=${this.state.property_id}`, {
      data: this.state.idList,
      previousId: this.state.lease_id,
      propertyidlist: this.state.propertyidlist,
    });
  };

  render() {
    // const currencyFormatter = new Intl.NumberFormat("en-AU", {
    //   style: "currency",
    //   currency: "AUD",
    //   minimumFractionDigits: 0,
    //   maximumFractionDigits: 0,
    // });
    const routeNavigationIds = Array.isArray(this.props.location.state?.data) ? this.props.location.state.data : [];
    const navigationIds = this.state.idList.length > 0 ? this.state.idList : routeNavigationIds;
    const navigationIndex = this.state.currentIdIndex !== null && this.state.currentIdIndex >= 0
      ? this.state.currentIdIndex
      : navigationIds.findIndex((id) => String(id) === String(this.props.match.params.id));
    const navigationPreviousId = navigationIndex > 0 ? navigationIds[navigationIndex - 1] : null;
    const navigationNextId = navigationIndex >= 0 && navigationIndex + 1 < navigationIds.length ? navigationIds[navigationIndex + 1] : null;
    return (
      <div className="Lease">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                cssOverride={{ display: "block", margin: "0 auto", borderColor: "red" }}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {this.state.showHeadOfficeSearchDialog && <HeadOfficeModal isAuthenticated={this.props.isAuthenticated} user={this.props.user} toggleHeadOfficeSearchDialog={this.toggleHeadOfficeSearchDialog} leaseid={this.state.lease_id} show={this.state.showHeadOfficeSearchDialog} data={this.state.headOfficeMatches} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} validateRelatedRecord={this.validateRelatedRecord} />}
        {this.state.lease && this.props.isAuthenticated && !this.state.isLoading && (
          <div className="LeaseForm">
            <Form>
              <Row>
                <Col>
                  <h6>
                    Lease Details - {this.state.lessee_trading} | {this.state.property_key} | {this.state.suite} {this.state.level_desc} | {this.state.expiry_date ? Moment(this.state.expiry_date).local().format("DD-MM-YYYY") : Moment().format("DD-MM-YYYY")}
                  </h6>
                </Col>
                <Col>
                  <Nav className="justify-content-center align-items-center flex-wrap">
                    {navigationPreviousId !== null && (
                      <Nav.Item className="d-flex align-items-center mr-1 mb-2">
                        <LinkContainer to={`/properties/${this.state.property_key}/leases/${navigationPreviousId}`} state={{ data: navigationIds, propertyidlist: this.state.propertyidlist }}>
                          <Button type="button" variant="info" size="sm" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }}>
                            Previous
                          </Button>
                        </LinkContainer>
                      </Nav.Item>
                    )}

                    {navigationNextId !== null && (
                      <Nav.Item className="d-flex align-items-center mr-1 mb-2">
                        <LinkContainer to={`/properties/${this.state.property_key}/leases/${navigationNextId}`} state={{ data: navigationIds, propertyidlist: this.state.propertyidlist }}>
                          <Button type="button" variant="info" size="sm" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }}>
                            Next
                          </Button>
                        </LinkContainer>
                      </Nav.Item>
                    )}
                    {navigationIndex >= 0 && navigationIds.length > 0 && (
                      <Form.Group as={Row} controlId="currentIdIndex" className="mb-1">
                        <Col className="zeroPadRight">
                          <Form.Control onChange={this.handleCurrentIdIndexChange} value={this.state.currentIdInput} as="input" type="text" min="0" className="pageCount" onBlur={this.handleGoToRecord} onKeyDown={this.handleEnterCurrentIdIndex} />
                        </Col>
                        <Col className="zeroPadLeft">
                          <h6>
                            <div className="topPad">of {navigationIds.length} </div>
                          </h6>
                        </Col>
                      </Form.Group>
                    )}
                  </Nav>
                </Col>

                <Col md={7} lg={6}>
                  <Nav className="justify-content-end align-items-center flex-wrap">
                    <Nav.Item className="d-flex align-items-center pr-2 mb-1">Lease Number Lookup:</Nav.Item>
                    <Nav.Item className="d-flex align-items-center mr-2 mb-1">
                      <Form.Group controlId="leaseNumberLookup" size="small" style={{ width: "100px" }} className="mb-0">
                        <Form.Control onChange={this.handleChange} onBlur={this.handleLeaseNumberLookup} value={this.state.leaseNumberLookup ? this.state.leaseNumberLookup : ""} as="input" type="text" className="leaseNumerLookup" />
                      </Form.Group>
                    </Nav.Item>
                    {this.state.lease_id && (
                      <Nav.Item className="d-flex align-items-center mr-1 mb-1">
                        <Button type="button" variant="primary" size="sm" onClick={this.handleAddNew}>
                          Add New
                        </Button>
                      </Nav.Item>
                    )}
                    {!this.state.archived && (
                      <Nav.Item className="d-flex align-items-center mr-1 mb-1">
                        <Button variant="primary" onClick={this.handleClone} size="sm" type="button">
                          Clone
                        </Button>
                      </Nav.Item>
                    )}
                    {!this.state.archived && (
                      <Nav.Item className="d-flex align-items-center mr-2 mb-1 position-relative">
                        <Form.Group controlId="clonePropertyKey" size="small" className="mb-0" style={{ width: "10rem" }}>
                          <Form.Control onChange={this.handleChange} value={this.state.clonePropertyKey ? this.state.clonePropertyKey : ""} as="input" type="text" className="leaseClone" />
                        </Form.Group>
                        <small className="text-muted position-absolute" style={{ top: "100%", left: 0, whiteSpace: "nowrap" }}>
                          <i>leave blank if same Property</i>
                        </small>
                      </Nav.Item>
                    )}
                    {!this.state.lease_id && (
                      <Nav.Item className="d-flex align-items-center mr-1 mb-1">
                        <LinkContainer
                          to={
                            this.state.previousId !== null && this.state.previousId !== undefined
                              ? `/properties/${this.state.property_key}/leases/${this.state.previousId}`
                              : `/properties/${this.state.property_key}`
                          }
                          state={
                            this.state.previousId !== null && this.state.previousId !== undefined
                              ? { data: this.state.idList, propertyidlist: this.state.propertyidlist }
                              : { tab: "leases", data: this.state.propertyidlist }
                          }
                        >
                          <Button type="button" variant="danger" size="sm" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }}>
                            Cancel Add New
                          </Button>
                        </LinkContainer>
                      </Nav.Item>
                    )}
                    <Nav.Item className="d-flex align-items-center mr-1 mb-1">
                      <LinkContainer to={`/properties/${this.state.property_key}`} state={{ tab: "leases", data: this.state.propertyidlist }}>
                        <Button type="button" variant="primary" size="sm" className="d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap" }}>
                          Back to Property {this.state.property_key}
                        </Button>
                      </LinkContainer>
                    </Nav.Item>
                    <Nav.Item className="d-flex align-items-center mr-1 mb-1">
                      <Button type="button" variant="danger" size="sm" onClick={this.handleArchive}>
                        Archive
                      </Button>
                    </Nav.Item>
                    <Nav.Item className="d-flex align-items-center mb-1">
                      <Button type="button" variant="danger" size="sm" onClick={this.handleDelete}>
                        Remove
                      </Button>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
              <Row className="show-grid with-margin" id="leasetabs">
                <Col>
                  <Modal
                    show={this.state.showAlert && this.state.lease_id ? true : false}
                    onHide={(e) => {
                      this.setState({ showAlert: !this.state.showAlert });
                    }}
                    centered
                  >
                    <Modal.Header closeButton>
                      {" "}
                      <Modal.Title>Uh Oh!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {" "}
                      <Alert variant="danger">{this.state.errorMessage}</Alert>{" "}
                    </Modal.Body>
                  </Modal>
                  {this.state.showAlert && !this.state.lease_id && <Alert variant="danger">{this.state.errorMessage}</Alert>}
                  {this.state.showWarning && <Alert variant="warning">{this.state.errorMessage}</Alert>}
                  <Tabs defaultActiveKey={0} id="tabset">
                    <Tab eventKey={0} title="Details">
                      <Row className="show-grid with-margin" id="detail">
                        <Col>
                          <Card id="leasedetails">
                            <Card.Body>
                              <Row>
                                <Col sm={12} md={12} lg={3}>
                                  <Card>
                                    <Card.Header>Lease Dealing</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="lease_number" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Lease Number
                                        </Form.Label>

                                        <Col>
                                          <Form.Control
                                            onChange={this.handleChange}
                                            value={this.state.lease_number ?? ""}
                                            as="input"
                                            type="text"
                                            size="small"
                                            onBlur={this.handleLeaseBlur}
                                            // id="lease_number"
                                          />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="archived" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Archived
                                        </Form.Label>

                                        <Col>
                                          <Form.Check checked={this.state.archived} onChange={this.handleCheckBoxChange} name="archived" type="checkbox" onBlur={this.handleBlur} disabled={!this.state.archived} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="created_date">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Created Date
                                        </Form.Label>
                                        <Col>
                                          <DatePicker selected={this.state.created_date ? new Date(this.state.created_date) : null} onChange={(e) => this.handleDateChange(e, "created_date")} dateFormat="dd/MM/yyyy" className="form-control" onBlur={this.handleBlur} format={null} />
                                        </Col>
                                      </Form.Group>

                                      <Row>
                                        <Col sm={2} md={2} lg={1}></Col>
                                        <Col>
                                          <Form.Group as={Row} controlId="registered" size="small">
                                            <Form.Label className="text-right" column>
                                              Registered
                                            </Form.Label>

                                            <Col>
                                              <Form.Check checked={this.state.registered} onChange={this.handleCheckBoxChange} name="registered" type="checkbox" onBlur={this.handleBlur} />
                                            </Col>
                                          </Form.Group>
                                        </Col>
                                        <Col>
                                          <Form.Group as={Row} controlId="sublease" size="small">
                                            <Form.Label className="text-right" column>
                                              Sublease
                                            </Form.Label>

                                            <Col>
                                              <Form.Check checked={this.state.sublease} onChange={this.handleSubleaseChange} type="checkbox" name="sublease" onBlur={this.handleBlur} />
                                            </Col>
                                          </Form.Group>
                                        </Col>
                                      </Row>

                                      <Form.Group as={Row} controlId="master_lease_number" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Master Lease
                                        </Form.Label>

                                        <Col>
                                          <Form.Control onChange={this.handleMasterLeaseChange} value={this.state.master_lease_number ? this.state.master_lease_number : ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="property_key" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Cityscope Reference
                                        </Form.Label>

                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.property_key ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>

                                  <Card>
                                    <Card.Header>Tenant Detail</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="lessee_registered" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Lessee Registered
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.lessee_registered ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="acn" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          ACN
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.acn ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="lessee_trading" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Lessee Trading
                                        </Form.Label>
                                        <Col>
                                          <Form.Control name="lessee_trading" onChange={this.handleChange} value={this.state.lessee_trading ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="classification_code" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Broad Type
                                        </Form.Label>
                                        <Col>
                                          <Select value={this.state.selectedClassification} onChange={this.handleClassificationChange} options={this.props.leaseClassificationOptions} onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="still_an_occ" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Still Here
                                        </Form.Label>
                                        <Col>
                                          <div className="d-flex align-items-center" >
                                            <Form.Check checked={this.state.still_an_occ} onChange={this.handleCheckBoxChange} name="still_an_occ" type="checkbox" onBlur={this.handleBlur} className="mb-0" />
                                          </div>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="include_cs_text" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Include in Text
                                        </Form.Label>
                                        <Col>
                                          <div className="d-flex align-items-center">
                                            <Form.Check checked={this.state.include_cs_text} onChange={this.handleCheckBoxChange} name="include_cs_text" type="checkbox" onBlur={this.handleBlur} className="mb-0" />
                                          </div>
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>

                                  <Card>
                                    <Card.Header>Lease Tenure</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="start_date">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Start
                                        </Form.Label>

                                        <Col>
                                          <DatePicker selected={this.state.start_date ? new Date(this.state.start_date) : null} onChange={(e) => this.handleDateChange(e, "start_date")} dateFormat="dd/MM/yyyy" className="form-control" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="expiry_date" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Expiry
                                        </Form.Label>

                                        <Col>
                                          <DatePicker selected={this.state.expiry_date ? new Date(this.state.expiry_date) : null} onChange={(e) => this.handleDateChange(e, "expiry_date")} dateFormat="dd/MM/yyyy" className="form-control" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="options" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Options
                                        </Form.Label>
                                        <Col>
                                            <Form.Check checked={this.state.options} onChange={this.handleCheckBoxChange} name="options" type="checkbox" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="options_text" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Options Text
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.options_text ? this.state.options_text : ""} as="input" type="text" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>
                                </Col>

                                <Col sm={12} md={12} lg={3}>
                                  <Card>
                                    <Card.Header>Space Leased</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="building_name" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Building Name
                                        </Form.Label>
                                        <Col>
                                          <Select value={this.state.selectedBuildingName} onChange={this.handleBuildingNameChange} options={this.state.buildingNameOptions} onBlur={this.handleBlur} isClearable />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="fronting" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Fronting
                                        </Form.Label>
                                        <Col>
                                          <Select value={this.state.selectedFronting} onChange={this.handleFrontingChange} options={this.state.frontingOptions} onBlur={this.handleBlur} isClearable />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="suite" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Suite
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.suite ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="level_desc" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Level Desc
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.level_desc ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="extra_desc" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Extra Desc
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.extra_desc ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="multi_level" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          No of Levels
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.multi_level ?? ""} as="input" type="number" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="level_number" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Level Number
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.level_number ?? ""} as="input" type="number" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="floor_type" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Floor Type
                                        </Form.Label>
                                        <Col>
                                          <Select value={this.state.selectedFloorType} onChange={this.handleFloorTypeChange} options={this.state.floorTypeOptions} onBlur={this.handleBlur} className="no-border" />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="area" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Area
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <Form.Control onChange={this.handleNumberChange} value={this.state.area ?? ""} as="input" type="number" onBlur={this.handleBlur} />
                                            <InputGroup.Text>m2</InputGroup.Text>
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="area_from_lease" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Area from Lease
                                        </Form.Label>
                                        <Col>
                                          <Form.Check checked={this.state.area_from_lease} onChange={this.handleCheckBoxChange} name="area_from_lease" type="checkbox" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="car_parking" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Car Parking
                                        </Form.Label>
                                        <Col>
                                          <Form.Check checked={this.state.car_parking} onChange={this.handleCheckBoxChange} name="car_parking" type="checkbox" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="number_of_car_parks" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          No. Car Parks
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.number_of_car_parks ?? ""} as="input" type="number" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>
                                </Col>

                                <Col sm={12} md={12} lg={3}>
                                  <Card>
                                    <Card.Header>Tenant Contact</Card.Header>
                                    <Card.Body>
                                      {this.state.led_head_office_id && (
                                        <Row>
                                          <Col sm={6} md={6} lg={4}></Col>
                                          <Col>
                                            <div>
                                              <font color="blue">
                                                This tenant has a head office. Edit details in the head office.
                                                <br />
                                                <br />
                                              </font>
                                            </div>
                                          </Col>
                                        </Row>
                                      )}

                                      <Form.Group as={Row} controlId="telephone" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Telephone
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.telephone ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="fax" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Fax
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.fax ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="weburl" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          URL
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>www.</InputGroup.Text>
                                            <Form.Control onChange={this.handleChange} value={this.state.weburl ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="email" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Email
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>@</InputGroup.Text>
                                            <Form.Control onChange={this.handleChange} value={this.state.email ?? ""} as="input" type="email" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="address_line_1" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Address Line 1
                                        </Form.Label>
                                        <Col>
                                          {" "}
                                          <Form.Control onChange={this.handleChange} value={this.state.address_line_1 ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="address_line_2" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Address Line 2
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.address_line_2 ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>
                                      {!this.state.led_head_office_id && (
                                        <Form.Group as={Row} controlId="suburb" size="small">
                                          <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                            Suburb
                                          </Form.Label>
                                          <Col>
                                            <AsyncSelect loadOptions={this.loadOptions} value={this.state.selectedSuburb} onChange={this.handleSuburbChange} onInputChange={this.handleInputChange} disabled={this.state.led_head_office_id ? true : false} onCreateOption={this.handleCreateSuburb} />
                                          </Col>
                                        </Form.Group>
                                      )}
                                      {this.state.led_head_office_id && (
                                        <Form.Group as={Row} controlId="suburb" size="small">
                                          <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                            Suburb
                                          </Form.Label>
                                          <Col>
                                            {" "}
                                            <Form.Control onChange={this.handleChange} value={this.state.suburb ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                          </Col>
                                        </Form.Group>
                                      )}
                                      <Form.Group as={Row} controlId="state" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          State
                                        </Form.Label>
                                        <Col>
                                          {" "}
                                          <Form.Control onChange={this.handleChange} value={this.state.state ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="postcode" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Postcode
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.postcode ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} disabled={this.state.led_head_office_id ? true : false} />
                                        </Col>
                                      </Form.Group>
                                      {!this.state.led_head_office_id && (
                                        <div>                                          
                                          <Form.Group as={Row} controlId="includeLevel" size="small">
                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                              Include Level
                                            </Form.Label>
                                            <Col>
                                              <div className="d-flex align-items-center">
                                                <Form.Check checked={this.state.includeLevel} onChange={this.handleCheckBoxChange} name="includeLevel" type="checkbox" onBlur={this.handleBlur} className="mb-0" />
                                              </div>
                                            </Col>
                                          </Form.Group>

                                          <Row>
                                            <Col>
                                              <Button onClick={this.handleAddressBuild} variant="secondary" size="sm">
                                                Build Address
                                              </Button>
                                            </Col>
                                            <Col>
                                              <Button onClick={this.handleAddressClear} variant="secondary" size="sm">
                                                Clear Address
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>
                                      )}
                                      <hr />

                                      {this.state.led_head_office_id && (
                                        <Row>
                                          <Col>
                                            <LinkContainer to={`/headoffices/${this.state.led_head_office_id}`} state={{ leaseid: this.state.lease_id, propertyid: this.state.property_id, data: this.state.idList }}>
                                              <Button variant="secondary" size="sm">
                                                View Head Office
                                              </Button>
                                            </LinkContainer>
                                          </Col>
                                          <Col>
                                            <Button type="button" onClick={this.handleDeleteHeadOfficeLink} variant="secondary" size="sm">
                                              Break Head Office Link
                                            </Button>
                                          </Col>
                                        </Row>
                                      )}
                                      {!this.state.led_head_office_id && (
                                        <Row>
                                          <Col>
                                            <Button type="button" onClick={this.handleCreateHeadOffice} variant="secondary" size="sm">
                                              Create Head Office
                                            </Button>
                                          </Col>
                                          <Col>
                                            <Button type="button" onClick={this.searchHeadOffices} variant="secondary" size="sm">
                                              Link to Head Office
                                            </Button>
                                          </Col>
                                        </Row>
                                      )}
                                    </Card.Body>
                                  </Card>
                                  <Card>
                                    <Card.Header>Property Addresses</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="property_suburb" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Suburb
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.property_suburb ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} readOnly />
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="title_details" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Title
                                        </Form.Label>
                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.title_details ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} readOnly />
                                        </Col>
                                      </Form.Group>
                                      <AddressList filter={this.state.addressFilter} isAuthenticated={this.props.isAuthenticated} controlType="list" data={this.state.addresses} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                    </Card.Body>
                                  </Card>
                                  <Card>
                                    <Card.Header>Property Owners</Card.Header>
                                    <Card.Body>
                                      <PropertyOwnerList filter={this.state.propertyOwnerFilter} isAuthenticated={this.props.isAuthenticated} controlType="list2" data={this.state.propertyOwners} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} />
                                    </Card.Body>
                                  </Card>
                                </Col>

                                <Col sm={4} md={4} lg={3}>
                                  <Card>
                                    <Card.Header>Rental Information</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="base_rent" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Base Rent PA
                                        </Form.Label>

                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>$</InputGroup.Text>

                                            <Form.Control
                                              onChange={this.handleNumberChange}
                                              value={this.state.base_rent ?? ""} //? currencyFormatter.format(this.state.base_rent):this.state.base_rent}
                                              as="input"
                                              type="text"
                                              size="small"
                                              onBlur={this.handleBlur}
                                            />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="base_rent_per_sqm" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Base Rent per SQM
                                        </Form.Label>

                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>$</InputGroup.Text>
                                            <Form.Control onChange={this.handleNumberChange} value={this.state.base_rent_per_sqm ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="car_parking_rent" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Car Park Rent PA
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>$</InputGroup.Text>
                                            <Form.Control onChange={this.handleNumberChange} value={this.state.car_parking_rent ?? ""} as="input" type="text" onBlur={this.handleBlur} />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="rent_free_period" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Months Rent Free
                                        </Form.Label>

                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.rent_free_period ?? ""} as="input" type="number" size="small" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="outs_percent" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Outgoings
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <Form.Control onChange={this.handlePercentChange} value={this.state.outs_percent ? this.state.outs_percent : ""} as="input" type="text" size="small" onBlur={this.handleBlur} placeholder="0.0000" />
                                            <InputGroup.Text>%</InputGroup.Text>
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="outs_per_sqm" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Outgoings per SQM
                                        </Form.Label>
                                        <Col>
                                          <InputGroup>
                                            <InputGroup.Text>$</InputGroup.Text>
                                            <Form.Control onChange={this.handleNumberChange} value={this.state.outs_per_sqm ?? ""} as="input" type="text" size="small" onBlur={this.handleBlur} />
                                          </InputGroup>
                                        </Col>
                                      </Form.Group>
                                      <Form.Group as={Row} controlId="rent_outs_notes" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Rent/Outgoings Notes
                                        </Form.Label>

                                        <Col>
                                          {" "}
                                          <Form.Control onChange={this.handleChange} value={this.state.rent_outs_notes ?? ""} as="textarea" type="text" rows="4" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>
                                  <Card>
                                    <Card.Header>Lease Notes</Card.Header>
                                    <Card.Body>
                                      <Form.Group as={Row} controlId="special_notes" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          Special Notes <br /> (appear to the customer)
                                        </Form.Label>

                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.special_notes ?? ""} as="textarea" type="text" rows="4" onBlur={this.handleBlur} />
                                        </Col>
                                      </Form.Group>

                                      <Form.Group as={Row} controlId="general_notes" size="small">
                                        <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                                          General Notes
                                          <br /> (internal only)
                                        </Form.Label>

                                        <Col>
                                          <Form.Control onChange={this.handleChange} value={this.state.general_notes ?? ""} as="textarea" type="text" rows="14" onBlur={this.handleBlur} bsPrefix="internal" />
                                        </Col>
                                      </Form.Group>
                                    </Card.Body>
                                  </Card>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </Tab>

                    <Tab eventKey={1} title="Reviews">
                      <Card>
                        <Card.Body>
                          <b>DO NOT PERFORM ANY CALCULATIONS MANUALLY.</b>
                          <br />
                          <br />
                          <LeaseReviewList filter={this.state.leaseReviewFilter} leaseId={this.state.lease_id} isAuthenticated={this.props.isAuthenticated} user={this.props.user} data={this.state.leaseReviews} updateTableState={this.updateTableState} saveRecord={this.saveRecord} deleteRecord={this.deleteRecord} refreshDataSet={this.refreshDataSet} leaseTermOptions={this.state.leaseTermOptions} reviewTypeOptions={this.props.reviewTypeOptions} validateRelatedRecord={this.validateRelatedRecord} />
                        </Card.Body>
                      </Card>
                    </Tab>

                    <Tab eventKey={3} title="Record History">
                      <Card style={{ width: "28rem" }}>
                        <Card.Body>
                          <Form.Group as={Row} controlId="created_date">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Created Date
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.created_date != null ? Moment(this.state.created_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="created_by">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Created By
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.created_by ?? ""} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="last_edited_date">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Last Edited Date
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.last_edited_date != null ? Moment(this.state.last_edited_date).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                            </Col>
                          </Form.Group>

                          <Form.Group as={Row} controlId="last_edited_by">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Last Edited By
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.last_edited_by ?? ""} plaintext readOnly />
                            </Col>
                          </Form.Group>
                          <Form.Group as={Row} controlId="date_archived">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>
                              Archived Date
                            </Form.Label>
                            <Col>
                              <Form.Control value={this.state.date_archived != null ? Moment(this.state.date_archived).local().format("DD-MM-YYYY") : ""} plaintext readOnly />
                            </Col>
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </Tab>
                  </Tabs>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

function LeaseDetailWithRouter(props) {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const history = {
    push: (to, stateArg) => {
      if (typeof to === "string") {
        navigate(to, { state: stateArg });
        return;
      }

      if (to && typeof to === "object") {
        const pathname = to.pathname || "";
        const search = to.search ? (to.search.startsWith("?") ? to.search : `?${to.search}`) : "";
        const state = to.state !== undefined ? to.state : stateArg;
        navigate(`${pathname}${search}`, { state });
      }
    },
  };

  return <LeaseDetail {...props} match={{ params }} location={location} history={history} />;
}

export default LeaseDetailWithRouter;


